import React from 'react'

interface Props {
  resource: string | any
  className?: string
  children?: any
}

enum nodeType {
  PAGE = 'Page',
  POST = 'Post',
  WHITEPAPER = 'Whitepaper',
  WEBINAR = 'Webinar',
  CASESTUDY = 'Casestudy',
  TOOLKIT = 'Tool',
  INFOGRAPHIC = 'Infographic',
}

enum resourceBgClass {
  PAGE = 'bg-blue',
  POST = 'bg-aqua',
  TOOLKIT = 'bg-aqua-seafoam',
  WHITEPAPER = 'bg-magenta',
  WEBINAR = 'bg-purple',
  INFOGRAPHIC = 'bg-blue-sky',
  CASESTUDY = 'bg-purple-lavender',
}

const ResourceBadge: React.FC<Props> = ({ resource, className, children }): JSX.Element => {
  let resourceClass

  if (resource === nodeType.POST) {
    resourceClass = resourceBgClass.POST
  } else if (resource === nodeType.PAGE) {
    resourceClass = resourceBgClass.PAGE
  } else if (resource === nodeType.WHITEPAPER) {
    resourceClass = resourceBgClass.WHITEPAPER
  } else if (resource === nodeType.CASESTUDY) {
    resourceClass = resourceBgClass.CASESTUDY
  } else if (resource === nodeType.TOOLKIT) {
    resourceClass = resourceBgClass.TOOLKIT
  } else if (resource === nodeType.WEBINAR) {
    resourceClass = resourceBgClass.WEBINAR
  } else if (resource === nodeType.INFOGRAPHIC) {
    resourceClass = resourceBgClass.INFOGRAPHIC
  } else {
    resourceClass = nodeType.PAGE
  }

  return (
    <div
      className={`${resourceClass} rounded-3xl px-4 py-1 body-5 text-white text-center ${className}`}
    >
      {children}
    </div>
  )
}

export default ResourceBadge
